export const isoTimestampToReadable = (timestamp) => {
  return new Date(timestamp).toISOString().slice(0, 19).replace("T", " ");
};

export const convertToIst = (dt) => {
  const date = new Date(dt);
  const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
  return new Date(date.getTime() + istOffset);
};

export const timeStampComparision = (lastChatTimestamp, numOfHrs) => {
  const currentTime = new Date() / 1000;

  if (currentTime - lastChatTimestamp > numOfHrs * 3600) return false;
  return true;
};
